import { render } from "./SmallModal.vue?vue&type=template&id=e24f5e18&scoped=true"
import script from "./SmallModal.vue?vue&type=script&lang=js"
export * from "./SmallModal.vue?vue&type=script&lang=js"

import "./SmallModal.vue?vue&type=style&index=0&id=e24f5e18&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24f5e18"]])

export default __exports__